export const APP_OUTDATED = 'app/outdated';

export default function appOutdated(isOutdated) {
  return {
    type: APP_OUTDATED,
    payload: {
      isOutdated,
    },
  };
}
